/**
 * Hope Award Recipients block script.
 *
 * Featured grid (top 4 honorees) gets a staggered fade-in — opacity only, no
 * translate. Translation on portraits creates a "shimmer" effect that distracts
 * from the people being honored. Archive lists below stay static (long lists
 * + per-item stagger would feel mechanical).
 */

import { revealStagger, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-hope-award-recipients').forEach((section) => {
		const featuredGrid = section.querySelector(':scope > div:first-child');
		if (!featuredGrid) return;

		revealStagger(featuredGrid, {
			childSelector: ':scope > .rmh-hope-award-featured',
			stagger: 0.08,
			duration: motionTokens.durMd,
			distance: 0,
		});
	});
});
